import requests from "./httpService";

const CommiossionServices = {
    getAllCommission: async () => {
        return requests.get(`/seller-commision`);
    },
    updateSellerCommissionStatus: async (id, body) => {
        return requests.patch(`/seller-commision/update-commission-status/${id}`, body);
    },
    updateSellerblockStatus: async (id, body) => {
        return requests.patch(`/seller/updateBlockStatus/${id}`, body);
    },
      updateSellerCommission: async (id, body) => {
        return requests.put(`/seller-commision/update-commission/${id}`, body);
    },
  createSellerCommission: async (body) => {
        return requests.post(`/seller-commision/create-commission`, body);
    },
    deleteCommission: async (id) => {
        return requests.delete(`/seller-commision/delete-commission/${id}`);
    },
}

export default CommiossionServices;